(function(){
'use strict';
var D=window.FT_GS||{};
var COLL='/collections/the-mix';
function px(h){var v=D[h];return v===undefined?null:v;}
function isB(h){return !!h&&D[h]!==undefined;}
var CSS=''
+'.gs-note{display:block;margin-top:5px;font:600 11px/1.3 inherit;letter-spacing:.01em;color:#C0412F}'
+'.gs-note a{color:inherit;text-decoration:none;border-bottom:1px solid currentColor}'
+'.gs-box{border:1.5px solid #C0412F;border-radius:4px;padding:15px 16px;margin:16px 0;background:rgba(192,65,47,.05)}'
+'.gs-box .h{font:600 11px/1 ui-monospace,monospace;letter-spacing:.09em;color:#C0412F;margin-bottom:8px}'
+'.gs-box p{margin:0 0 8px;font-size:13px;line-height:1.5;color:#4A4F59}'
+'.gs-box a{font-weight:600;color:#C0412F;font-size:13px;border-bottom:1px solid currentColor;text-decoration:none}'
+'.gs-cart{border:1.5px solid #C0412F;border-radius:4px;padding:13px 15px;margin:14px 0;background:rgba(192,65,47,.06);font-size:13px;line-height:1.5;color:#15171C}'
+'.gs-cart .h{font:600 11px/1 ui-monospace,monospace;letter-spacing:.08em;color:#C0412F;margin-bottom:7px}'
+'.gs-cart a{font-weight:600;color:#C0412F;border-bottom:1px solid currentColor;text-decoration:none}'
+'.gs-free{display:inline-block;font:600 10px/1 ui-monospace,monospace;letter-spacing:.06em;color:#fff;background:#1E7A4B;padding:4px 7px;border-radius:2px;margin-left:6px;vertical-align:middle}'
+'.ft-col__badge--sale{white-space:nowrap}';
var st=document.createElement('style');st.textContent=CSS;(document.head||document.documentElement).appendChild(st);
var MONEY=/(?:LE|EGP|E£)\s*[\d.,]+/i;
var SALEB='.ft-col__badge--sale,[class*="badge--sale"],[class*="flag--sale"],[class*="sale-badge"]';
var LBL='BUY 1 GET 1';
var CUR='LE ';
function fmt(n){return CUR+Number(n).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});}
function detectCur(){var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT),n;while((n=w.nextNode())){var m=n.nodeValue.match(/(LE|EGP)\s?\d/);if(m){CUR=m[1]+' ';return;}}}
function hf(h){if(!h)return null;var m=h.split('?')[0].split('#')[0].match(/\/products\/([^\/]+)\/?$/);return m?m[1]:null;}
function hOf(c){var href=null;
if(c.tagName==='A'&&/\/products\//.test(c.getAttribute('href')||''))href=c.getAttribute('href');
else{var a=c.querySelector('a[href*="/products/"]');if(a)href=a.getAttribute('href');}
return hf(href);}
function mn(root){var o=[],w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,{acceptNode:function(n){return MONEY.test(n.nodeValue)?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_REJECT;}}),n;while((n=w.nextNode()))o.push(n);return o;}
function flag(c){
var b=c.querySelector(SALEB);
if(b){if(b.textContent.trim()!==LBL)b.textContent=LBL;return;}
var img=c.querySelector('.ft-col__img');
if(!img){var i=c.querySelector('img');img=i?i.parentElement:null;}
if(!img||img.querySelector('[data-gs-b]'))return;
try{if(getComputedStyle(img).position==='static')img.style.position='relative';}catch(e){}
var s=document.createElement('span');s.className='ft-col__badge ft-col__badge--sale';s.setAttribute('data-gs-b','1');s.textContent=LBL;
img.appendChild(s);
}
function flags(){
document.querySelectorAll('.ft-col__card,product-card,.product-card').forEach(function(c){
if(isB(hOf(c)))flag(c);
});
}
function card(c){
if(c.getAttribute('data-gs'))return;
if(c.closest&&c.closest('.ft-home'))return;
if(!isB(hOf(c)))return;
c.setAttribute('data-gs','1');
var pn=mn(c)[0];
if(pn&&pn.parentElement){var hd=pn.parentElement;if(hd.parentElement&&hd.parentElement!==c)hd=hd.parentElement;
var s=document.createElement('span');s.className='gs-note';s.innerHTML='<a href="'+COLL+'">Second piece free →</a>';hd.insertAdjacentElement('afterend',s);}
}
function cards(){
var cs=document.querySelectorAll('product-card,.product-card');
if(cs.length){cs.forEach(card);return;}
document.querySelectorAll('a[href*="/products/"]').forEach(function(a){
if(a.closest('.ft-home,.ft-pdp__info,.ft-pdp__wrap,[class*="swatch"],[class*="color-strip"],[class*="review"],nav,header,footer'))return;
if(!isB(hf(a.getAttribute('href'))))return;
var el=a,c=a;for(var i=0;i<5&&el;i++){el=el.parentElement;if(!el)break;if(el.querySelector('img')&&MONEY.test(el.textContent||'')){c=el;break;}c=el;}
if(c&&c.querySelector('a[href*="/products/"]'))card(c);
});
}
function pdp(){
var m=location.pathname.match(/\/products\/([^\/]+)/);if(!m)return;
if(!isB(m[1]))return;
var main=document.querySelector('main')||document.body;
main.querySelectorAll(SALEB).forEach(function(b){if(b.closest('.ft-col__card,product-card,.product-card'))return;if(b.textContent.trim()!==LBL)b.textContent=LBL;});
var info=document.querySelector('.ft-pdp__info')||main;
if(info.getAttribute('data-gs-pdp'))return;info.setAttribute('data-gs-pdp','1');
var row=document.querySelector('.ft-pdp__price-row')||info;
var b=document.createElement('div');b.className='gs-box';
b.innerHTML='<div class="h">BUY 1 GET 1 FREE</div><p>Add any two pieces from the collection and the second comes off at checkout. Nothing to enter, no code.</p><a href="'+COLL+'">See the collection →</a>';
row.insertAdjacentElement('afterend',b);
}
window.FT_GS_H={fmt:fmt,D:D,COLL:COLL,px:px,isB:isB};
function run(){pdp();cards();flags();}
function boot(){detectCur();run();
var mo=new MutationObserver(function(){clearTimeout(window.__gsT);window.__gsT=setTimeout(run,150);});
mo.observe(document.body,{childList:true,subtree:true});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
